import { onMounted, onUnmounted, ref } from 'vue'

export function useViewport() {
    const vh = ref(0)
    const vw = ref(0)

    const updateViewport = () => {
        // Используем visualViewport API если доступен для мобильных браузеров
        // visualViewport.height более точно отражает видимую область при скролле
        const height = window.visualViewport?.height || window.innerHeight
        const width = window.visualViewport?.width || window.innerWidth

        vh.value = height * 0.01
        vw.value = width * 0.01
        document.documentElement.style.setProperty('--vh', `${vh.value}px`)
        document.documentElement.style.setProperty('--vw', `${vw.value}px`)
    }

    onMounted(() => {
        updateViewport()
        window.addEventListener('resize', updateViewport)
        window.addEventListener('orientationchange', updateViewport)

        // Этот API срабатывает при изменении видимой области при скролле
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', updateViewport)
            window.visualViewport.addEventListener('scroll', updateViewport)
        }
    })

    onUnmounted(() => {
        window.removeEventListener('resize', updateViewport)
        window.removeEventListener('orientationchange', updateViewport)

        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', updateViewport)
            window.visualViewport.removeEventListener('scroll', updateViewport)
        }
    })

    return { vh, vw }
}
